module.exports = __webpack_public_path__ + "5501748ca36637dd296645e8d99ad5e7.svg";